import React from "react";
import styles from "./AdvancedIvfLab.module.css";
import useDeviceWidth from "../../../../components/device-width/UseDeviceWidth";
import { useLocation, useNavigate } from "react-router-dom";
import AdvancedIvfLabPattern from "../../../../components/UI/AdvancedIvfLabPattern";
import AdvancedIvfLabPatternTab from "../../../../components/UI/AdvancedIvfLabPatternTab";
import AdvancedIvfLabPatternMob from "../../../../components/UI/AdvancedIvfLabPatternMob";
import { NavigationContext } from "../../../../App";
import { useContext } from "react";

const AdvancedIvfLab = ({ data }) => {
  const width = useDeviceWidth();
  const navigate = useNavigate();
  const location = useLocation();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  return (
    <section className={styles.section}>
      {/* <img
        className={styles.pattern}
        src="https://via.placeholder.com/1200x800/000000/333333?text=Pattern"
        alt="Pattern"
      /> */}
      {width > 1200 ? (
        <AdvancedIvfLabPattern className={styles.pattern} />
      ) : width > 768 ? (
        <AdvancedIvfLabPatternTab className={styles.pattern} />
      ) : (
        <AdvancedIvfLabPatternMob className={styles.pattern} />
      )}
      <div className={styles.container}>
        {width > 768 && (
          <div className={styles.imageWrapper}>
            <img
              data-aos="fade-down"
              data-aos-delay="150"
              className={styles.mainImage}
              src={data?.listingItems[0]?.images[0]?.url}
              alt={data?.listingItems[0]?.images[0]?.imageTag}
            />
            {/* <div className={styles.backStyle}></div> */}
          </div>
        )}
        <div className={styles.content}>
          {data?.showTitle && (
            <div className={styles.title}>
              <div
                dangerouslySetInnerHTML={{ __html: data?.title }}
                data-aos="fade-right"
                data-aos-delay="150"
              ></div>
            </div>
          )}
          <h2
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.subtitle}
          >
            {data?.subTitle}
          </h2>
          {width <= 768 && (
            <div className={styles.imageWrapper}>
              <img
                data-aos="fade-down"
                data-aos-delay="150"
                className={styles.mainImage}
                src={data?.listingItems[0]?.images[0]?.url}
                alt={data?.listingItems[0]?.images[0]?.imageTag}
              />
              {/* <div className={styles.backStyle}></div> */}
            </div>
          )}
          <div
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: data?.listingItems[0]?.homeDescription,
            }}
          />
          <button
            data-aos="fade-down"
            data-aos-delay="150"
            onClick={() => {
              const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
              setIsBackNavigation(true)
              navigate(`/advanced-ivf`)}}
            className={`${styles.button} bg-primary-500 primary-hover2 border-primary-500`}
          >
            Know More
          </button>
        </div>
      </div>
    </section>
  );
};

export default AdvancedIvfLab;
